function getTitle(vm) {
    const { title } = vm.$options
    if (title) {
        return typeof title === 'function'
            ? title.call(vm)
            : title
    }
}
function updateTitle(vm) {
    const title = getTitle(vm)
    let documentTitle = "driblabPRO";
    if (title) {
        documentTitle = `${title} - ${documentTitle}`
    }
    window.document.title = documentTitle;
}

export default {
    created(){
        let { overrideWindowTitle } = this;
        if(overrideWindowTitle){
            updateTitle(this);
        }
    },
    beforeUpdate() {
        let { overrideWindowTitle } = this;
        if(overrideWindowTitle){
            updateTitle(this);
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/mixins/titleMixin.js